import loyaltyAnalytics from "@/services/loyalty.analytics";
import notification from "@/services/notification";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    loyaltyAnalyticsLink: null
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setError(state, errors) {
      state.errors = errors;
    },
    setLoyaltyAnalyticsLink(state, link) {
      state.loyaltyAnalyticsLink = link;
    }
  },
  actions: {
    async fetchLoyaltyAnalyticsLink({ commit }) {
      commit("setLoading", true);
      try {
        const { data } = await loyaltyAnalytics.fetchLoyaltyAnalyticsLink();
        commit("setLoyaltyAnalyticsLink", data.embed_url ? data.embed_url : null);
      } catch (errors) {
        commit("setError", errors);
        notification.warning("Ooops, something went wrong.");
      } finally {
        commit("setLoading", false);
      }
    }
  }
}
